import React from 'react';
import { Typography, Paper, Grid, Avatar } from '@mui/material';
import { ShapesInterface } from '../../../store/sellingCakeReport/api/interface';
import { getAssetURl } from '../../../utils/url';
import { isValidArray } from '../../../utils/valid';
import { useAppSelector } from '../../../store';

interface IProps {
  topSellingShapes: ShapesInterface[] | undefined;
  lessSellingShapes: ShapesInterface[] | undefined;
}

const Shapes: React.FC<IProps> = ({ topSellingShapes, lessSellingShapes }) => {
  const assetUrl = useAppSelector(
    (state) => state.active.selectedItem.assetUrl
  );
  return (
    <Paper
      elevation={3}
      sx={{ padding: 2, height: '100%' }}
    >
      <Typography
        variant='h6'
        gutterBottom
      >
        Shapes
      </Typography>
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          xs={12}
        >
          <Typography variant='subtitle1'>Most Sold</Typography>
        </Grid>
        {!isValidArray(topSellingShapes) && (
          <div className='center-class'>
            <Typography variant='body2'>{'No record found'}</Typography>
          </div>
        )}
        {topSellingShapes?.map((shape) => (
          <Grid
            item
            xs={6}
            key={shape?.labelEn}
          >
            <Avatar
              alt={shape?.previewUrl}
              imgProps={{ crossOrigin: 'anonymous' }}
              src={getAssetURl(shape?.previewUrl, assetUrl)}
              sx={{
                borderRadius: 'unset',
                m: 1,
                objectFit: 'contain',
                '& img': { objectFit: 'contain' },
                width: '100%',
              }}
            />
            <Typography
              variant='body1'
              align='center'
            >
              {shape?.labelEn} (Sold:{shape?.totalQuantitySold})
            </Typography>
          </Grid>
        ))}
        <Grid
          item
          xs={12}
        >
          <Typography variant='subtitle1'>Least Sold</Typography>
        </Grid>
        {!isValidArray(lessSellingShapes) && (
          <div className='center-class'>
            <Typography variant='body2'>{'No record found'}</Typography>
          </div>
        )}
        {lessSellingShapes?.map((shape) => (
          <Grid
            item
            xs={6}
            key={shape?.labelEn}
          >
            <Avatar
              alt={shape?.previewUrl}
              imgProps={{ crossOrigin: 'anonymous' }}
              src={getAssetURl(shape?.previewUrl, assetUrl)}
              sx={{
                borderRadius: 'unset',
                m: 1,
                objectFit: 'contain',
                '& img': { objectFit: 'contain' },
                width: '100%',
              }}
            />
            <Typography
              variant='body1'
              align='center'
            >
              {shape?.labelEn} (Sold:{shape?.totalQuantitySold})
            </Typography>
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
};

export default Shapes;
